import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'AssignPermissionToRolesListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AssignPermissionToRolesListUI/AssignPermissionToRolesListUI.vue'),
    },
    {
      name: 'AssignPermissionToRolesUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AssignPermissionToRolesUI/AssignPermissionToRolesUI.vue'),
    },
    {
      name: 'CommercialModuleEditUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CommercialModuleEditUI/CommercialModuleEditUI.vue'),
    },
    {
      name: 'CommercialModuleFeatureUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CommercialModuleFeatureUI/CommercialModuleFeatureUI.vue'),
    },
    {
      name: 'CommercialModuleListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CommercialModuleListUI/CommercialModuleListUI.vue'),
    },
    {
      name: 'CommercialModuleVolumetryUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CommercialModuleVolumetryUI/CommercialModuleVolumetryUI.vue'),
    },
    {
      name: 'CommercialSolutionEditUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CommercialSolutionEditUI/CommercialSolutionEditUI.vue'),
    },
    {
      name: 'CommercialSolutionListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CommercialSolutionListUI/CommercialSolutionListUI.vue'),
    },
    {
      name: 'CommercialSolutionLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CommercialSolutionLookupUI/CommercialSolutionLookupUI.vue'),
    },
    {
      name: 'CommercialSolutionModuleDetailUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CommercialSolutionModuleDetailUI/CommercialSolutionModuleDetailUI.vue'),
    },
    {
      name: 'CommercialSolutionModuleEditUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CommercialSolutionModuleEditUI/CommercialSolutionModuleEditUI.vue'),
    },
    {
      name: 'CommercialSolutionModuleListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CommercialSolutionModuleListUI/CommercialSolutionModuleListUI.vue'),
    },
    {
      name: 'CultureListUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CultureListUI/CultureListUI.vue'),
    },
    {
      name: 'CustomSubUIViewEntityViewParameterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomSubUIViewEntityViewParameterUI/CustomSubUIViewEntityViewParameterUI.vue'),
    },
    {
      name: 'CustomSubUIViewPropertyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomSubUIViewPropertyUI/CustomSubUIViewPropertyUI.vue'),
    },
    {
      name: 'CustomSubUIViewStyleRuleUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomSubUIViewStyleRuleUI/CustomSubUIViewStyleRuleUI.vue'),
    },
    {
      name: 'CustomSubUIViewUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomSubUIViewUI/CustomSubUIViewUI.vue'),
    },
    {
      name: 'CustomUIViewCreateUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewCreateUI/CustomUIViewCreateUI.vue'),
    },
    {
      name: 'CustomUIViewDataFilterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewDataFilterUI/CustomUIViewDataFilterUI.vue'),
    },
    {
      name: 'CustomUIViewEntityViewParameterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewEntityViewParameterUI/CustomUIViewEntityViewParameterUI.vue'),
    },
    {
      name: 'CustomUIViewGroupsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewGroupsUI/CustomUIViewGroupsUI.vue'),
    },
    {
      name: 'CustomUIViewListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewListUI/CustomUIViewListUI.vue'),
    },
    {
      name: 'CustomUIViewPropertyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewPropertyUI/CustomUIViewPropertyUI.vue'),
    },
    {
      name: 'CustomUIViewSortsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewSortsUI/CustomUIViewSortsUI.vue'),
    },
    {
      name: 'CustomUIViewStyleRuleUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomUIViewStyleRuleUI/CustomUIViewStyleRuleUI.vue'),
    },
    {
      name: 'CustomerEditUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomerEditUI/CustomerEditUI.vue'),
    },
    {
      name: 'CustomerListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomerListUI/CustomerListUI.vue'),
    },
    {
      name: 'EmojiListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EmojiListUI/EmojiListUI.vue'),
    },
    {
      name: 'FeatureEditUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/FeatureEditUI/FeatureEditUI.vue'),
    },
    {
      name: 'FeatureListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/FeatureListUI/FeatureListUI.vue'),
    },
    {
      name: 'FeatureLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/FeatureLookupUI/FeatureLookupUI.vue'),
    },
    {
      name: 'FeatureTechnicalFunctionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/FeatureTechnicalFunctionUI/FeatureTechnicalFunctionUI.vue'),
    },
    {
      name: 'HomePageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HomePageUI/HomePageUI.vue'),
    },
    {
      name: 'KnownIanaTimeZoneUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/KnownIanaTimeZoneUI/KnownIanaTimeZoneUI.vue'),
    },
    {
      name: 'LicenseEditUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LicenseEditUI/LicenseEditUI.vue'),
    },
    {
      name: 'LicenseFeatureUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LicenseFeatureUI/LicenseFeatureUI.vue'),
    },
    {
      name: 'LicenseListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LicenseListUI/LicenseListUI.vue'),
    },
    {
      name: 'LicenseLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LicenseLookupUI/LicenseLookupUI.vue'),
    },
    {
      name: 'LicenseModuleDetailListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LicenseModuleDetailListUI/LicenseModuleDetailListUI.vue'),
    },
    {
      name: 'LicenseModuleDetailUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LicenseModuleDetailUI/LicenseModuleDetailUI.vue'),
    },
    {
      name: 'LicenseModuleListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LicenseModuleListUI/LicenseModuleListUI.vue'),
    },
    {
      name: 'LicenseModuleUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/LicenseModuleUI/LicenseModuleUI.vue'),
    },
    {
      name: 'NeosBaseUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosBaseUI/NeosBaseUI.vue'),
    },
    {
      name: 'PermissionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PermissionUI/PermissionUI.vue'),
    },
    {
      name: 'TechnicalFunctionEditUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TechnicalFunctionEditUI/TechnicalFunctionEditUI.vue'),
    },
    {
      name: 'TechnicalFunctionListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TechnicalFunctionListUI/TechnicalFunctionListUI.vue'),
    },
    {
      name: 'TechnicalFunctionLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/TechnicalFunctionLookupUI/TechnicalFunctionLookupUI.vue'),
    },
    {
      name: 'UserAccountAvailableUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountAvailableUI/UserAccountAvailableUI.vue'),
    },
    {
      name: 'UserAccountListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountListUI/UserAccountListUI.vue'),
    },
    {
      name: 'UserAccountLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountLookupUI/UserAccountLookupUI.vue'),
    },
    {
      name: 'UserAccountUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUI/UserAccountUI.vue'),
    },
    {
      name: 'UserAccountUserRoleEntityUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleEntityUI/UserAccountUserRoleEntityUI.vue'),
    },
    {
      name: 'UserAccountUserRoleMultiClusterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleMultiClusterUI/UserAccountUserRoleMultiClusterUI.vue'),
    },
    {
      name: 'UserAccountUserRoleUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleUI/UserAccountUserRoleUI.vue'),
    },
    {
      name: 'UserPermissionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserPermissionUI/UserPermissionUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsJobUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsJobUI/UserReportPrintSettingsJobUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsListUI/UserReportPrintSettingsListUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsUI/UserReportPrintSettingsUI.vue'),
    },
    {
      name: 'UserRoleAssignmentUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserRoleAssignmentUI/UserRoleAssignmentUI.vue'),
    },
    {
      name: 'UserSettingsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserSettingsUI/UserSettingsUI.vue'),
    },
    {
      name: 'UserStartupTabUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserStartupTabUI/UserStartupTabUI.vue'),
    },
    {
      name: 'VolumetryTypeEditUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VolumetryTypeEditUI/VolumetryTypeEditUI.vue'),
    },
    {
      name: 'VolumetryTypeUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/VolumetryTypeUI/VolumetryTypeUI.vue'),
    },
  ],
}
